export const ACTION_TYPES = {
  UPDATE_VIEW_OPTIONS: "UPDATE_GROUP_MEMBERS_BY_SUPPLY",
  UPDATE_PROPERTIES: "UPDATE_PROPERTIES",
  UPDATE_LOADED_DATA: "UPDATE_LOADED_DATA",
  UPDATE_EXPANDED_TEAMS: "UPDATE_EXPANDED_TEAMS",
  UPDATE_LOADED_TEAMS: "UPDATE_LOADED_TEAMS",
  UPDATE_PERSON_PARTIAL: "UPDATE_PERSON_PARTIAL",
  UPDATE_EXPANDED_PANEL: "UPDATE_EXPANDED_PANEL",

  MERGE_PARTIAL_DATA: "MERGE_PARTIAL_DATA",
};
